import { GetStaticProps, InferGetStaticPropsType } from 'next'
import {
  Posts,
  PostsVariables,
  Posts_posts,
} from '@/apollo/__generated__/Posts'

import { POSTS } from '@/apollo/queries'
import { PostStatusType } from '@/apollo/__generated__/globalTypes'
import { __draft_post_enabled__ } from '@/constants'
import client from '@/apollo/apollo-client'

export { Posts as default } from '@/page-components/posts'

export const getStaticProps: GetStaticProps<{
  allPost: Posts_posts[] | null
}> = async () => {
  const { data } = await client.query<Posts, PostsVariables>({
    query: POSTS,
    variables: {
      where: !__draft_post_enabled__
        ? { status: { equals: PostStatusType.Published } }
        : undefined,
    },
  })

  return {
    props: {
      allPost: data.posts,
    },
    revalidate: 1,
  }
}

export type PostsPageProps = InferGetStaticPropsType<typeof getStaticProps>
